// What a bike card in the shop says and allows (bike plans 4 and 6), pure so node tests cover it. It reads
// gameState.raw: the catalog's designs and sell ratio (routers/state.py), the player's money and bikes — keyed by
// design, one of each design (bike plan 6). The checks run in the server's order (bike.buy_bike): an unknown design,
// that design already owned, then money. A bike sells for 80% of what was paid, or of its design's price when no
// price is on record (bike.sell_bike).

export const sellPrice = (paid, ratio) => Math.round(paid * ratio);

export const bikeDesigns = (catalog, type) => catalog?.bikes?.[type]?.designs ?? [];

// block: 'owned' (you have this design: sell it), 'unknown' (no such design, or no catalog yet), 'money', or null
// when Kup works.
export function bikeOffer(raw, type, designId) {
  const spec = raw?.catalog?.bikes?.[type];
  const design = bikeDesigns(raw?.catalog, type).find((d) => d.id === designId) ?? null;
  const mine = raw?.bikes?.[designId];
  const owned = !!mine?.owned;
  const block = !design ? 'unknown' : owned ? 'owned' : (raw?.money ?? 0) < design.price ? 'money' : null;
  return {
    type,
    design: design?.id ?? null,
    name: spec?.name_pl ?? 'Rowerek',
    designName: design?.name_pl ?? null,
    level: design?.level ?? null,
    price: design?.price ?? null,
    owned,
    sellPrice: owned ? sellPrice(mine.paid || design?.price || 0, raw?.catalog?.bike?.sell_ratio ?? 0.8) : null,
    block,
  };
}
